import React from "react";
import Skill from "./skill";
import shortid from "shortid";
import skillsData from "../data/skills.json";
import mystyles from "./skills.module.scss";
// import ihtml from "../images/moto.jpg";

const Skills = ({ children, props }) => (
  <div className={`ComponentSeparation`}>
    <h2 className={`${mystyles.header} t2`}>Skills:</h2>
    <div className={`${mystyles.skills}`}>
      {skillsData.map((skill, index) => {
        return (
          <div className={mystyles.li} key={shortid.generate()}>
            <Skill skill={skill.skillCategory} skillNames={skill.skillNames} />
          </div>
        );
      })}
    </div>
  </div>
);

export default Skills;

// <img src={ihtml} alt="" />
